import script from "./CxCombobox.vue?vue&type=script&setup=true&lang=ts"
export * from "./CxCombobox.vue?vue&type=script&setup=true&lang=ts"

import "./CxCombobox.vue?vue&type=style&index=0&id=b4f68754&lang=less"

const __exports__ = script;

export default __exports__